import { render, staticRenderFns } from "./filter-button.vue?vue&type=template&id=bab31fd2"
import script from "./filter-button.vue?vue&type=script&lang=js"
export * from "./filter-button.vue?vue&type=script&lang=js"
import style0 from "./filter-button.vue?vue&type=style&index=0&id=bab31fd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports